import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { merge, pick, isNil } from 'lodash';
import { push } from 'react-router-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import * as jobRequestApi from '../../../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../../../redux/actionCreators/sync/jobrequests';
import { validate, validateField } from '../../../../modelValidator';
import { convertToMenuItems, getLookupValue } from '../../../../redux/helpers/staticData';

import CheckList from '../../../../common/components/c_CheckList';
import DropDownMenu from '../../../../common/components/c_DropDownMenu';
import DateInput from '../../../../common/components/DateInput';
import ToggleButton from '../../../../common/components/c_ToggleButton';
import SubmissionBar from '../../SubmissionBar';

import RouteTransitionBlocker from '../../../r_ApplicantDashboard/f_RouteTransitionBlocker';

@connect((store, props) => {
	return {
		staticData: store.staticData,
		user: store.user,
		jobRequest: store.jobRequest,
		jobId: parseInt(props.params.jobId || 0, 10),
    labels: store.labels.jobRequest.workschedule || {}
	};
})
class WorkSchedule extends Component {

	static propTypes = {
		staticData: PropTypes.object.isRequired,
		user: PropTypes.object,
		checkComplete: PropTypes.func,
		params: PropTypes.object.isRequired
	}

	constructor(props, context) {
		super(props, context);

		this.state = {
			clientId: this.props.user.id,
			isDirty: false,
			errors: [],
			jobRequest: null,
			jobRequestModel: {
				...this.props.jobRequest,
				id: this.props.jobId,
				primaryContactId: this.props.user.profileId,
			},
			showTransitionBlocker: false,
			transitionRoute: '',
			stateSaved: true
		};
		this.jobWorkScheduleModel = {
			jobTypeId: {
				required: {
					message :'This field is required.'
				}
			},
			numberOfMonths: {},
			dateEnded: {},
			dateStarted: {
				required: {
					message :'This field is required.'
				}
			},
			estimatedHoursPerWeek: {
				required: {
					message :'This field is required.'
				}
			},
			partTimeWahvesConsidered: {

			},
			workdays: {
				required: {
					message :'This field is required.'
				}
			},
			offHoursConsidered: {
				required: {
					message :'This field is required.'
				}
			},
			timezone: {
				required: {
					message :'This field is required.'
				}
			},
			startTime: {
				required: {
					message :'This field is required.'
				}
			},
			endTime: {
				required: {
					message :'This field is required.'
				}
			}
		};

		this.handleDropDownMenuUI = ::this.handleDropDownMenuUI;
		this.handleDateProperties = ::this.handleDateProperties;
		this.handleToggleButtonUI = ::this.handleToggleButtonUI;
		this.handleChange = ::this.handleChange;
	}

	componentDidMount() {

		this.props.router.setRouteLeaveHook(this.props.route, (location) => {

			const jobRequestSteps = /\/client\/jobrequest\/(.*)\/?(.*)/;

			if (jobRequestSteps.test(location.pathname)) {
				this.state.primaryButtonLabel = 'Stay';
				this.state.secondaryButtonLabel = 'Leave';

			}else{
				this.state.primaryButtonLabel = undefined;
				this.state.secondaryButtonLabel = undefined;
			}

			if (!this.state.stateSaved) {
				this.setState(merge({}, this.state, {showTransitionBlocker: true,  transitionRoute: location.pathname}));
				return this.state.stateSaved;
			}

			return true;

		});
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.jobRequest) {
			this.setState(merge({}, this.state, {jobRequestModel: nextProps.jobRequest}));
		}
	}

	handleDropDownMenuUI(prop, menuItems, label) {
		return {
			'data-id': `dropdown-${prop}`,
			menuItems,
			value: this.state.jobRequestModel[prop],
			floatingLabelText: label,
			errorText: (this.state.isDirty) ? validateField(this.state.jobRequestModel[prop], this.jobWorkScheduleModel[prop])[0] : undefined,
			onChange: this.handleChange(prop)
		};
	}

	handleDateProperties(prop, label) {
		return {
			'data-id': `date-${prop}`,
			defaultValue: this.state.jobRequestModel[prop],
			floatingLabelText: label,
			errorText: validateField(this.state.jobRequestModel[prop], this.jobWorkScheduleModel[prop])[0],
			isDirty: this.state.isDirty,
			onBlur: this.handleChange(prop)
		};
	}

	handleToggleButtonUI(prop, label) {
		return {
			'data-id': `tooglebutton-${prop}`,
			value: this.state.jobRequestModel[prop],
			errorText: (this.state.isDirty) ? validateField(this.state.jobRequestModel[prop], this.jobWorkScheduleModel[prop])[0] : undefined,
			onChange: this.handleChange(prop),
			floatingLabelText: label || null
		};
	}

	handleChange(prop) {
		return (event, value) => {
			const jobRequest = this.state.jobRequestModel;
			jobRequest[prop] = value;
			if((prop === 'numberOfMonths' || prop === 'dateStarted') &&
			(!isNil(jobRequest.dateStarted) && !isNil(jobRequest.numberOfMonths))) {
				jobRequest.dateEnded = moment(jobRequest.dateStarted).add(jobRequest.numberOfMonths, 'months').format();
			}
			this.setState(merge({}, this.state, {jobRequestModel: jobRequest, stateSaved:false}));
		};
	}

	save = (clientId, jobRequestModel, jobWorkScheduleModel) => {

		// Pick only the neccesary fields for the request.

		const jobWorkScheduleFields = ['id', 'primaryContactId', ...Object.keys(jobWorkScheduleModel)];
		const jobWorkSchedule = pick(jobRequestModel,  jobWorkScheduleFields);

		return this.props.dispatch(jobRequestApi.updateJobRequest(clientId, jobWorkSchedule))
			.then(() => {
				this.props.dispatch(jobRequestStore.updateJobRequest({...this.state.jobRequestModel}));
			});

	}

	handleSave = (event, cb) => {

		this.save(this.state.clientId, this.state.jobRequestModel, this.jobWorkScheduleModel)
			.then(() =>  this.setState({stateSaved: true}, cb));
	}

	handleSaveAndNext = (event) => {

		const errors = validate(this.state.jobRequestModel, this.jobWorkScheduleModel);
		this.state.errors = [];

		if(this.state.jobRequestModel.startTime > this.state.jobRequestModel.endTime) {
			this.state.errors.push('Preferred Start Time can not be after than Preferred End Time.');
		}


		if(this.state.jobRequestModel.hardcodelink === 'PROJECT' && new Date(this.state.jobRequestModel.dateStarted) > new Date(this.state.jobRequestModel.dateEnded)) {
			this.state.errors.push('Desired Start Date can not be after than Projected End.');
		}

		this.handleSave(event, () => {

			if (errors.length > 0 || this.state.errors.length > 0) {
				this.setState({isDirty: true});
			}else{
				this.props.checkComplete();
				this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/addcontact`));
			}

		});

	}

	handleBack = () => {
		this.props.dispatch(push(`/client/jobrequest/${this.props.jobId||0}/skills/summary`));
	}

	closeTransitionBlocker = () => {
		this.setState(merge({}, this.state, {showTransitionBlocker: false}));
	}

	transitionFunction = () => {
		this.setState({stateSaved: true}, () =>  this.props.dispatch(push(this.state.transitionRoute)));
	}

	render() {

		const jobIs = convertToMenuItems(this.props.staticData.jobTypes, 'id', 'name', 'subElement');

		const numberOfMonth = [
			{
				primaryText: '6',
				subElement: null,
				value : 6
			}, {
				primaryText: '7',
				subElement: null,
				value : 7
			}, {
				primaryText: '8',
				subElement: null,
				value : 8
			}, {
				primaryText : '9',
				subElement: null,
				value : 9
			}, {
				primaryText : '10',
				subElement: null,
				value : 10
			}, {
				primaryText: '11',
				subElement: null,
				value : 11
			}, {
				primaryText: '1 yr',
				subElement: null,
				value : 12
			}, {
				primaryText: '2 yrs',
				subElement: null,
				value : 24
			}];


		const yesNo = [{value: true, primaryText: 'Yes', subElement: null}, {value: false, primaryText: 'No', subElement: null}];

		const hoursPerWeek = [
			{
				primaryText: 20,
				subElement: null,
				value: 20
			}, {
				primaryText: 25,
				subElement: null,
				value: 25
			}, {
				primaryText: 30,
				subElement: null,
				value: 30
			}, {
				primaryText: 35,
				subElement: null,
				value: 35
			}, {
				primaryText: 37.5,
				subElement: null,
				value: 37.5
			}, {
				primaryText: 40,
				subElement: null,
				value: 40
			}

		];

		const daysPerWeek = this.props.staticData.dayAvailableTypes;
		const preferredStartTime = convertToMenuItems(this.props.staticData.workHours.slice(0, 25), 'id', 'name', 'subElement');
		const preferredEndTime = convertToMenuItems(this.props.staticData.workHours.slice(6, this.props.staticData.workHours.length), 'id', 'name', 'subElement');

		const jobType = getLookupValue(this.props.staticData, 'jobTypes', {id: this.state.jobRequestModel.jobTypeId});
		const isProjectType = jobType && jobType.hardcodelink === 'PROJECT';

		return (
			<div className='work-schedule'>
			{
				this.state.showTransitionBlocker
						&&
				<RouteTransitionBlocker
					cancelAction={this.closeTransitionBlocker.bind(this)}
					primaryAction={this.closeTransitionBlocker.bind(this)}
					primaryButtonLabel={this.state.primaryButtonLabel}
					secondaryAction={this.transitionFunction.bind(this)}
					secondaryButtonLabel={this.state.secondaryButtonLabel}
					transitionText={'You are leaving the Job Request record. Please click on Save first before you exit.'}
				/>
			}
					<h1>Work Schedule</h1>
					<div className='form-section-content clearfix'>

            <div className='headings-row clearfix'>
							<div className='center-column-1'>
								This job is:
							</div>

              <div className='center-column-1'>
                Desired Start Date:
              </div>

							{isProjectType ?
								<div className='center-column-1'>
										<div className='half-width'>
											Number of months:
										</div>
										<div className='half-width'>
											Projected End Date:
										</div>
								</div>
							: null}
						</div>

						<DropDownMenu className='question-dropdown center-column-1 drop-plain'
              includeDefault
              floatingLabelStyle={{top: '-13px'}}
							{...this.handleDropDownMenuUI('jobTypeId', jobIs, '')}
						/>

						<DateInput
							autoOk
							minDate={new Date()}
              className='center-column-1 date-input'
              textStyle={ {margin: '0px'} }
							{...this.handleDateProperties('dateStarted', '')}
						/>

						{(isProjectType) &&
							<div className='center-column-1'>
								<DropDownMenu className='half-width'
                  floatingLabelStyle={{overflow: 'visible', top: '-13px'}}
									{...this.handleDropDownMenuUI('numberOfMonths', numberOfMonth, '')}
								/>
								<DateInput
									autoOk
									minDate={new Date()}
                  className='half-width date-input'
                  textStyle={ {margin: '0px'} }
									{...this.handleDateProperties('dateEnded', '')}
								/>
							</div>
						}
					</div>
					<div className='form-section-content clearfix'>
						<div className='headings-row clearfix'>
							<div className='center-column-1'>
								Estimated Number of Hours per Week:
							</div>
							{this.state.jobRequestModel.estimatedHoursPerWeek === 40 ?
								<div className='center-column-1'>{this.props.labels.partTime}</div>
							: null}
						</div>
						<DropDownMenu className='question-dropdown center-column-1 drop-plain'
							{...this.handleDropDownMenuUI('estimatedHoursPerWeek', hoursPerWeek, '')}
						/>
						{this.state.jobRequestModel.estimatedHoursPerWeek === 40 ? //
							<ToggleButton className='center-column-1'
								menuItems={yesNo}
								{...this.handleToggleButtonUI('partTimeWahvesConsidered', '')}
							/>
						: null}
					</div>
					<div className='form-section-content clearfix'>
						<div className='headings-row clearfix'>
							<div className='center-column-1'>
								Days of the week:
							</div>

							<div className='center-column-1'>
								Can work be performed outside business hours?
							</div>

							<div className='center-column-1'>
								Job Time Zone:
							</div>
						</div>
						<CheckList className='question-dropdown center-column-1 drop-plain'
							defaultValue={this.state.jobRequestModel.workdays}
							{...this.handleDropDownMenuUI('workdays', daysPerWeek, '')}
						/>
						<ToggleButton className='center-column-1'
							menuItems={yesNo}
							{...this.handleToggleButtonUI('offHoursConsidered', '')}
						/>
						<DropDownMenu className='question-dropdown center-column-1 drop-plain'
							{...this.handleDropDownMenuUI('timezone', this.props.staticData.timezoneList, '')}
						/>
					</div>
					<div className='form-section-content clearfix'>
						<div className='headings-row clearfix'>
							<div className='center-column-1'>
								Preferred Start Time:
							</div>
							<div className='center-column-1'>
								Preferred End Time:
							</div>
						</div>


						<DropDownMenu canAutoPosition={true} className='question-dropdown center-column-1 drop-plain'
							{...this.handleDropDownMenuUI('startTime', preferredStartTime, '')}
						/>
						<DropDownMenu canAutoPosition={true} className='question-dropdown center-column-1 drop-plain'
							{...this.handleDropDownMenuUI('endTime', preferredEndTime, '')}
						/>
					</div>
					<SubmissionBar
						onBack={this.handleBack}
						onNext={this.handleSaveAndNext}
						onSave={this.handleSave}
						showError={this.state.isDirty}
						errors={this.state.errors}
					/>

			</div>);
	}
}
export default withRouter(WorkSchedule);



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/WorkSchedule/index.js